import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './sustainability.json';

const Sustainability = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Environmental vocabulary, green living, and climate action. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="Sustainability"
            image="/Images/sustainability.webp"
            seoTitle="Free English Lesson Plans: Sustainability"
            seoDescription="Environmental vocabulary, green living, and climate action. B2/C1 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Sustainability;


